/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Sample_TwoInputs */

const en_coaches_page_sample_two = /** @type {(inputs: Coaches_Page_Sample_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michael Reed`)
};

const pl_coaches_page_sample_two = /** @type {(inputs: Coaches_Page_Sample_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michał Zieliński`)
};

/**
* | output |
* | --- |
* | "Michael Reed" |
*
* @param {Coaches_Page_Sample_TwoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_sample_two = /** @type {((inputs?: Coaches_Page_Sample_TwoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Sample_TwoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_sample_two(inputs)
	return en_coaches_page_sample_two(inputs)
});